// cl-stickers-group
;(({ $$ }) => {
    $$('.js-cl-stickers-group').forEach(group => {  
        const shower = group.querySelector('.js-cl-stickers-group__shower')
        const hider = group.querySelector('.js-cl-stickers-group__hider')
        const dynamics = group.querySelectorAll('.js-cl-stickers-group__dynamic')

        if (!shower || !hider) { return }

        shower.addEventListener('click', event => {
            event.preventDefault()
            showDynamics()
        })

        hider.addEventListener('click', event => {
            event.preventDefault()
            hideDynamics()
        })

        function showDynamics() {
            dynamics.forEach(d => d.style.display = 'flex')
            shower.style.display = 'none'
            hider.style.display = 'flex'
        }

        function hideDynamics() {
            dynamics.forEach(d => d.style.display = 'none')
            shower.style.display = 'flex'
            hider.style.display = 'none'
        }
    })
})(CNS);